import * as Phaser from "phaser-ce"
import { TransitionState } from "../../GameState"
import { Buttons } from "../../generic-sprites/Buttons"
import { loadGenericAssets } from "../../generic-sprites/GenericAssets"
import { CameraZoom } from "../../utils/CameraZoom"
import { Scale } from "../../utils/Scale"
import { KidsChoiceAudio, loadAssets } from "./KidsChoiceAssets"
import { KidsChoiceSharedState, setupKidsChoiceShared } from "./KidsChoicePartOneState"
import { KidsChoiceStore } from "./KidsChoiceStore"
import { KidsChoiceCategoryType, KidsChoiceSpriteType } from "./KidsChoiceTypes"
import { KidsChoiceCategoryContainer } from "./sprites/KidsChoiceCategoryContainer"
import { KidsChoiceSpriteCreator } from "./sprites/KidsChoiceSpriteCreator"
import { KidsChoiceVideoSelectContainer } from "./sprites/KidsChoiceVideoSelectContainer"

export class KidsChoicePartTwoState extends Phaser.State implements KidsChoiceSharedState {
    sprites: KidsChoiceSpriteCreator
    backgroundGroup: Phaser.Group
    private currentCategory: KidsChoiceVideoSelectContainer

    async preload() {
        loadGenericAssets(this.game)
        loadAssets(this.game)
    }

    async create() {
        await setupKidsChoiceShared(this, false)
    }

    displayOptions = () => {
        let audio
        let makeNextButton = false
        if (KidsChoiceStore.instance.viewedHealthVotes && KidsChoiceStore.instance.viewedSecondhandVotes) {
            audio = this.game.add.audio(KidsChoiceAudio.SEEN_BOTH_RESULTS)
            makeNextButton = true
        } else if (KidsChoiceStore.instance.viewedHealthVotes || KidsChoiceStore.instance.viewedSecondhandVotes) {
            audio = this.game.add.audio(KidsChoiceAudio.CLICK_OTHER_CATEGORY)
        } else {
            audio = this.game.add.audio(KidsChoiceAudio.SEE_CLASSMATES_VOTED)
        }
        const categories = this.sprites.create(KidsChoiceSpriteType.CATEGORY_SELECT, {group: this.backgroundGroup}) as KidsChoiceCategoryContainer
        categories.addOnClick(KidsChoiceCategoryType.HEALTH_EFFECTS, () => this.startCategory(KidsChoiceCategoryType.HEALTH_EFFECTS, this.returnToTheater))
        categories.addOnClick(KidsChoiceCategoryType.SECONDHAND_SMOKE, () => this.startCategory(KidsChoiceCategoryType.SECONDHAND_SMOKE, this.returnToTheater))
        audio.onPlay.add(categories.disable)
        audio.onStop.add(() => {
            categories.enable(KidsChoiceCategoryType.SECONDHAND_SMOKE)
            categories.enable(KidsChoiceCategoryType.HEALTH_EFFECTS)
            if (makeNextButton) {
                Buttons.create(this.game, "Next", () => {
                    CameraZoom.resetZoom(this.game)
                    this.game.state.start(TransitionState.KIDS_CHOICE_2_EXIT)
                }, {
                    y: Scale.y(0.71), centerInWorldX: true
                })
            }
        })
        audio.play()
    }

    startCategory = (type: KidsChoiceCategoryType, onEnd: () => void) => {
        this.sprites.destroyAll()
        this.createVideoSelectionScreen(type, onEnd)
    }

    returnToTheater = () => {
        this.sprites.destroyAll()
        this.displayOptions()
    }

    private createVideoSelectionScreen = (type: KidsChoiceCategoryType, onEnd: () => void): KidsChoiceVideoSelectContainer =>
        this.currentCategory = this.sprites.create(KidsChoiceSpriteType.VIDEO_SELECT, {
            type,
            onEnd,
            group: this.backgroundGroup
        }) as KidsChoiceVideoSelectContainer
}
